import React from 'react'

const items = [
   { icon: "🐍", title: "Python", text: "Découvrir les bases de la programmation" },
   { icon: "🧩", title: "Logique", text: "Comprendre la logique et les algorithmes" },
   { icon: "🛠️", title: "Outils Pros", text: "Prendre en main GitHub, Flask et Streamlit" },
   { icon: "🌐", title: "Web & IA", text: "Créer des applis web et explorer l’IA" },
]

function ProgramHighlights() {
   return (
      <section className="py-20 bg-light-4">
         <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-title font-bold text-dark-2 text-center mb-12">💡 Ce que tu apprendras</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
               {items.map((item, idx) => (
                  <div
                     key={idx}
                     whileHover={{ y: -8 }}
                     className="bg-white rounded-2xl p-6 text-center"
                  >
                     <div className="text-3xl mb-3">{item.icon}</div>
                     <h3 className="text-lg font-semibold text-dark-2 mb-2">{item.title}</h3>
                     <p className="text-normal text-dark-3">{item.text}</p>
                  </div>
               ))}
            </div>
         </div>
      </section>
   )
}

export default ProgramHighlights